window.addEventListener("load", function () {
  // ターゲットの設定
  const targets = document.querySelectorAll("#page-top-hidden-mark");
  // 操作する要素を指定
  const control = document.querySelector(".page-top");

  if (control !== null) {
    // 交差した時の処理とオプション
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            control.classList.remove("hidden");
          } else {
            control.classList.add("hidden");
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0,
      }
    );
    // ターゲットを監視する
    targets.forEach((target) => {
      // ターゲット要素の高さを調整する用
      target.style.height = `calc(${
        document.body.scrollHeight
      }px - ${window.getComputedStyle(target).getPropertyValue("--top")})`;
      // ターゲットに交差APIを設定
      observer.observe(target);
    });
  }
});
